export enum InviteStatus {
  Accepted = 'Accepted',
  Expired = 'Expired',
  Pending = 'Pending',
}

// Ordering matters as it affects the sorting order
export enum ProjectStatus {
  Default = 'Default',
  InProgress = 'In Progress',
  Overdue = 'Overdue',
  Pending = 'Pending',
  Unassigned = 'Unassigned',
}

export enum RecurrenceType {
  ONE_OFF = 'One-Off',
  ONGOING = 'Ongoing',
  MULTIPLE = 'Multiple',
}

export enum AuditCategory {
  ONE_OFF = 'One-off',
  ONGOING = 'Ongoing',
  MULTIPLE = 'Cycle',
}

export enum MultipleRecurrenceType {
  DAILY = 'Daily',
  WEEKLY = 'Weekly',
  MONTHLY = 'Monthly',
  YEARLY = 'Yearly',
}

export enum AuditType {
  BASELINE = 'baseline',
  FOLLOWUP = 'followUp',
}

export enum AuditSiteType {
  SINGLE_SITE = 'singleSite',
  MULTI_SITE = 'multiSite',
}

export enum AuditSamplingType {
  TARGET_SAMPLE_SIZE = 'targetSampleSize',
  AD_HOC = 'adHoc',
  CONSECUTIVE = 'consecutive',
}

export enum SamplingMode {
  CRITERIA_BASED = 'criteriaBased',
  SITE_BASED = 'siteBased',
}

export enum ConsecutiveSamplingMode {
  TARGET_SAMPLE = 'targetSample',
  MIN_AND_MAX = 'minAndMax',
}
